import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import DriveThruAffiliateHeader from "../driveThruAffiliateHeader/driveThruAffiliateHeader.component";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

// NOTE: No Session 11 images were provided with the writeup.
// If you add them later, import them here and add <ImageComponent /> blocks inside sections.
// Example:
import cover from "../../../../src/assets/blade-runner/session11/blade-runner-session-11-cover.webp";
import coco from "../../../../src/assets/blade-runner/session11/coco-and-whiskers.webp";
import wall from "../../../../src/assets/blade-runner/session11/sepulveda-sea-wall.webp";
import mccoy from "../../../../src/assets/blade-runner/session11/mccoy-sniper.webp";
import ready from "../../../../src/assets/blade-runner/session11/getting-ready.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};

const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession11 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});

  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => setShowModal("show");
  const handleCloseModal = () => setShowModal("", "");

  const section1Data = [
    {
      title: "Safehouse: (Sector 9, Night)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={cover}
            caption="Mother"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion recover with HIP FLASK and Skinner settles his nerves with ORIGAMI."
          ></ImageComponent>

          {/* Optional cover image if you add one later */}
          {/* <ImageComponent
            image={cover}
            caption="Sector 9 Safehouse"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 11: The safehouse holds two identical men and one ugly truth."
          ></ImageComponent> */}

          <p>
            Skinner hauls <strong>McCoy</strong> into one of Grimsky’s Rueboy
            safehouses—an abandoned warehouse in <strong>Sector 9</strong>.
            Downstairs, Rueboys loiter in the dim, pretending not to stare.
            Upstairs, Skinner dumps the injured man onto a cot. It's hard-won,
            shabby mercy while he and Marion try to clear their names and can
            get McCoy to a real facility safely.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
          <br />
        </div>
      ),
    },
    {
      title: "Calling Coco: The Encrypted Hunch (LAPD Network, Off-Book)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={coco}
            caption="Coco"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Coco examines evidence of replicant McCoy while Whiskers assists."
          ></ImageComponent>

          <p>
            Skinner pings <strong>Coco</strong>—not through official channels in
            any way that feels safe. He dumps photos, blood prints, and the kind
            of evidence that can get a detective erased if the wrong eyes see
            it.
          </p>

          <p>
            Skinner doesn’t dress it up. He tells Coco the truth:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “I don’t know who is in on it, but I want you to look at these. I
              have a feeling about you. I know I give you a hard time, but I
              trust you. There’s a plot against us.”
            </font>
          </p>

          <p>
            The transmission goes out <strong>encrypted</strong>—tight enough
            not to light up the police network like a flare. Not perfect. Just
            survivable.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Sepulveda Sea Wall: The Crab Shack Sniper (Roofline & Neon)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={wall}
            caption="Sepulveda Sea Wall"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Sepulveda Sea Wall is a warren of jetties and makeshift docks jammed together at the base of the wall, stitched from scrap lumber, rusted rebar, and whatever the adjacent metropolis spits out. In the constant driving rain, with Pacific waves pounding the settlement, the pier lines feel less like public infrastructure and more like a survival maze: narrow walkways over black water, boats tied off at bad angles, and stilt-houses leaning out over the chop. It’s also an informal harbor—a place the Replicant Underground uses to quietly ferry fugitive Replicants out of LA, with rendezvous sometimes happening out on the farthest jetty, where you’re “lashed by waves” and exposed to anyone watching from shore."
          ></ImageComponent>

          <p>
            Marion and Skinner take a bent, grey, egg-shaped maintenance flyer
            toward the <strong>Sepulveda Sea Wall</strong>—where rumors say the
            replicant underground still breathes, quietly, under the city’s
            boot.
          </p>
          <p>
            The Sepulveda Sea Wall is a warren of jetties and makeshift docks
            jammed together at the base of the wall, stitched from scrap lumber,
            rusted rebar, and whatever the adjacent metropolis spits out. In the
            constant driving rain, with Pacific waves pounding the settlement,
            the pier lines feel less like public infrastructure and more like a
            survival maze: narrow walkways over black water, boats tied off at
            bad angles, and stilt-houses leaning out over the chop. It’s also an
            informal harbor—a place the Replicant Underground uses to quietly
            ferry fugitive Replicants out of LA, with rendezvous sometimes
            happening out on the farthest jetty, where you’re “lashed by waves”
            and exposed to anyone watching from shore.
          </p>

          <p>
            As Skinner lands them on the roof of a warehouse along the pier,
            Marion catches it: a flicker of movement on the roof of{" "}
            <strong>Mei’s Crab House</strong>. A metallic glint. A long gun
            barrel. Then nothing—just ductwork and shadows.
          </p>

          <p>
            Marion takes a swallow from his hip flask. Skinner takes a happy
            pill and folds an origami sniper figure—sets it on the edge like a
            tiny prophecy, barrel pointed at the crab shack.
          </p>

          <p>
            Marion climbs down, pushes through the rowdy chaos of the crab
            shack—stevedores, busted tables, cheap booze—and hits the service
            stairs to the roof.
          </p>

          <p>
            The moment the door cracks open, a shot rips the air. A ricochet
            screams past Marion’s head. No warning. Just intent.
          </p>

          <p>
            Skinner lifts the flyer and drifts over the roofline—spotting the
            shooter. It’s not a stranger.
          </p>

          <p>
            It’s <strong>McCoy</strong>.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Firefight: McCoy’s Eye / Skinner’s Hand (Blood on the Controls)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={mccoy}
            caption="Sniper McCoy"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Replicant McCoy with shattered orbital bone and ruined eye atop Mei's Crab Shack loading for shot at Skinner in maintenance craft hovering nearby."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={ready}
            caption="Getting Ready"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="Marion heals with slug from HIP FLASK as Skinner calms his nerves with ORIGAMI."
          ></ImageComponent>
          <p>
            McCoy braces by the massive holo-neon sign strut—like he’s holding
            up the whole lie with his shoulder.
          </p>

          <p>
            Marion gets a bead and fires a <strong>.44 caseless round</strong>.
            It hits hard—McCoy’s cheek erupts, orbital bone shatters, his{" "}
            <strong>left eye is destroyed</strong>. He falls back with a muffled
            grunt that sounds almost human.
          </p>

          <p>
            With his remaining eye, McCoy spots Skinner in the flyer.
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              “Fucking Skinner.”
            </font>{" "}
            Then he shoots.
          </p>

          <p>
            The round punches through weak flooring and chews straight into the
            cockpit—through <strong>Skinner’s hand</strong>, impaling it on the
            steering joystick like the city’s idea of a joke.
          </p>

          <p>
            Marion fires again. McCoy returns fire. Blood sprays. Neon flickers.
            Skinner glances at his mood ring—flashing{" "}
            <strong style={{ color: "#C21E56" }}>red</strong>.
          </p>

          <p>
            Skinner grits his teeth, forces his ruined hand to move, and dives
            the flyer straight down—clipping McCoy and smashing him into the
            sign strut with crushing force. It’s messy. It’s personal. It works.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Safehouse Redux",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          {/* Optional cover image if you add one later */}
          {/* <ImageComponent
            image={cover}
            caption="Sector 9 Safehouse"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 11: The safehouse holds two identical men and one ugly truth."
          ></ImageComponent> */}

          <p>
            After a tense discussion with local wharf punks, Marion decides to
            stay and get to know gang member Yumi better. Meawhile, Skinner
            brings in replicant <strong>McCoy</strong> to the safehouse, the{" "}
            <em>real</em> McCoy—already there, damaged and barely breathing. The
            Rueboys glance between the two bodies, unsettled by the symmetry.
            Same face. Same build. Two different kinds of wrong.
          </p>

          <p>
            Skinner binds the replicant “McCoy” tight near the bed. The mood
            ring on Skinner’s hand flickers like a warning light that can’t
            decide on a color.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Holden Calls It In: “Mother” & Wallace (The Wind Shifts)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <p>
            Marion is sitting with Yumi when an emergency LAPD call from Holden
            lights up his KIA, the pieces start snapping into place. Holden's
            voice tight, like he’s chewing glass in addition to his oxygen
            machine.
          </p>

          <p>
            Holden admits Coco’s report changed everything. The evidence makes
            it undeniable: the “McCoy” who fooled the brass is a{" "}
            <strong>replicant</strong>. Also—Skinner’s lookalike cracked and
            confessed.
          </p>

          <p>
            The confession was childlike and poisonous. He claims he and his
            “siblings” are doing <strong>Mother’s</strong> bidding—so she can{" "}
            <em>take back what is rightfully hers</em>. There’s a plan hatching
            at <strong>Wallace Corporation</strong> next shift.
          </p>

          <p>
            Holden can’t raise Quell or anyone at Wallace. He’s mobilizing
            squads, but he needs Skinner and Marion to get there{" "}
            <strong>ASAP</strong> and get a sitrep.
          </p>

          <p>
            Holden clears them—officially innocent now—but the apology doesn’t
            erase the blood on the floorboards.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Interrogation & Armory: Ezekiel, Noah, and Going Loud",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <p>
            Marion and Skinner swing through LAPD long enough to weaponize the
            truth. Skinner interrogates the captured “McCoy.”
          </p>

          <p>
            He won’t answer to McCoy anymore. He says his name is{" "}
            <strong>Ezekiel</strong>. The Skinner lookalike, he says, is{" "}
            <strong>Noah</strong>.
          </p>

          <p>
            Ezekiel refuses details—how many “siblings,” the specifics of the
            Wallace plan—only the core belief, delivered with cold certainty:
            <strong> Lilith Tyrell is Mother</strong>, and when she’s finished,
            humans will be servants at best—extinct if the universe feels kind.
          </p>

          <p>
            While Skinner works the prisoner, Marion cashes in Holden’s apology
            the only way that matters: gear. Premium pulls without the usual
            friction. He arms himself and Skiiner like they’re walking into a
            war:
          </p>

          <ul>
            <li>
              <strong>Ender assault rifles</strong>
            </li>
            <li>
              <strong>Tear gas</strong>
            </li>
            <li>
              <strong>A grenade</strong>
            </li>
          </ul>

          <p>
            Whatever Wallace is cooking, they’re not showing up with badges and
            hope. They’re showing up armed to the teeth.
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <DriveThruAffiliateHeader
                  gameName="Blade Runner"
                  logo={bladeRunnerLogo}
                  productUrl="https://www.drivethrurpg.com/en/product/399929/Blade-Runner-RPG-Core-Rulebook?affiliate_id=844642"
                  logoMaxWidth="200px"
                  logoStyle={{ backgroundColor: "white", borderRadius: "10px" }}
                />
              </main>

              <h1 className="cover-heading">MOTHER</h1>
              <small>Blade Runner Session 11</small>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner"
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Shootout at the Sepulveda Sea Wall. A confession. A plan
                  inside Wallace—the detectives sprinting toward danger.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Fiery Angels case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 10: <a href="./blade-runner-session-10">McCoy</a> ☠
                  Session 12: <a href="./blade-runner-session-12">Prophecy</a>{" "}
                  ⇒{" "}
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession11;
